import React, { useId } from 'react';

export const MaxBadge = ({ className = '', testId = 'max-badge' }) => {
  const gid = `max-grad-${useId().replace(/:/g, '')}`;
  return (
  <div
    data-testid={testId}
    aria-label="Мы в MAX"
    className={`inline-flex items-center gap-2.5 px-5 py-3 rounded-lg bg-white/5 border border-white/10 text-base font-medium text-white cursor-default select-none ${className}`}
  >
    <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true" className="shrink-0">
      <defs>
        <linearGradient id={gid} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#3FB8FF" />
          <stop offset="1" stopColor="#7A3CFF" />
        </linearGradient>
      </defs>
      <circle cx="12" cy="12" r="12" fill={`url(#${gid})`} />
      <path d="M7 16.5V8l5 5 5-5v8.5" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
    <span>Мы в MAX</span>
  </div>
  );
};
